import { memo } from 'react'
import { Alert as AlertType } from '../types'

interface AlertProps {
  alerts: AlertType[]
}

export const Alert = memo(({ alerts }: AlertProps) => {
  // Log alerts for debugging

  // Only render alerts if there are any
  if (!alerts || alerts.length === 0) return null

  return (
    <div className="alert-container" data-alert-container>
      {/* <div className="fixed top-[10vh] left-1/2 -translate-x-1/2 z-10 flex flex-col items-center"> */}
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className="alert"
          // className="pointer-events-none bg-[#dadce0] dark:bg-[#d7dadc]
          //            px-3 py-2 rounded mb-2 last:mb-0 opacity-100
          //            transition-opacity duration-500"
        >
          {alert.message}
        </div>
      ))}
    </div>
  )
})

Alert.displayName = 'Alert'
